import { useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";

import { getAbogados } from "../../../../../redux/Sections/Abogados/actions";
import { showTable } from "../../../../../redux/Sections/Inmuebles/actions";
import { tipoEtapasService } from "../../../../../_services/tipoEtapas.service";
import { useUser } from "../../../../../hooks/useUser";
import Select from "../../../../../components/Select";
import Swal from "sweetalert2";
import "./index.css";

export const Filter = ({ action, reference, showFilter, setShowFilter, setShowTable, tab, setFilters }) => {
  const dispatch = useDispatch();
  const user = useUser();

  const [tipos, setTipos] = useState([]);
  const [grupo, setGrupo] = useState("");

  const {
    register,
    handleSubmit,
    control,
    reset
  } = useForm({});

  const [tags, setTags] = useState({});

  useEffect(() => {
    const getData = () => {
      dispatch(getAbogados());
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      if (grupo && grupo.id) {
        let response = await tipoEtapasService.getTipoEtapas(3);

        if (response?.length) {
          setTipos(response.map(e => {
            return {
              ...e,
              value: e.tipo,
              label: e.nombre
            };
          }));
        }
        else {
          setTipos([]);
        }
      }
    };

    getData();
  }, [grupo]);

  const handleClean = () => {
    reset({});
    setTags({});
    setGrupo({});
  };

  const onSubmit = async (data) => {
    for (const value in data) {
      if (!data[value]) {
        delete data[value];
      }
    }

    if (Object.keys(data).length === 1 && data.situacion) {
      return Swal.fire({
        title: "No es posible buscar solo por 'estados'.",
        icon: "warning"
      });
    }

    setTags(data);

    if (data.nombre) {
      data.nombre = data.nombre.toUpperCase();
    }

    if ("A00" !== user?.abogado) {
      // data.usuario = user.dni;
    }

    if (setFilters) {
      setFilters(data);
    }
    await action(data);

    setShowFilter(false);
    if (setShowTable) {
      setShowTable(true);
    }
    dispatch(showTable());
  };

  const handleChange = (e) => {
    if (e) {
      setGrupo(e);
    }
    else {
      setGrupo("");
    }
  };

  const fields = useMemo(
    () => [
      [
        // {
        //   label: "Contribuyente",
        //   type: "text",
        //   name: "nombre",
        // },
        // {
        //   label: "Tipo",
        //   type: "select",
        //   name: "tipo",
        //   options: [{ value: "I", label: "Inmueble" }, { value: "C", label: "Comercio" }],
        // },
        {
          label: "N° imponible",
          type: "text",
          name: "nro_imponible",
        },
        {
          label: "Recurso",
          type: "text",
          name: "recurso",
        },
        // {
        //   label: "DNI",
        //   type: "text",
        //   name: "nro_doc",
        // },
      ],
      // [
      //   {
      //     label: "CUIT",
      //     type: "cuit",
      //     name: "cuit",
      //   },
      //   {
      //     label: "Barrio",
      //     type: "text",
      //     name: "barrio",
      //   },
      //   {
      //     label: "Calle",
      //     type: "text",
      //     name: "calle",
      //   },
      //   {
      //     label: "Altura",
      //     type: "text",
      //     name: "altura",
      //   },
      // ],
      //   [
      //     {
      //       label: "Estado de causa",
      //       type: "select",
      //       name: "estado_causa",
      //       options: tipos?.length ? [emptyOption, ...tipos] : [emptyOption],
      //     },
      //     {
      //       label: "Ultima fecha de movimiento",
      //       type: "date",
      //       name: "fecha_movimiento",
      //     },
      //     {
      //       label: "Ultima fecha de ingreso",
      //       type: "date",
      //       name: "fecha_ingreso",
      //     },
      //   ]
    ],
    [tipos]
  );

  const comercioFields = useMemo(
    () => [
      [
        {
          label: "Contribuyente",
          type: "text",
          name: "contrib",
        },
        {
          label: "N° de Comercio",
          type: "text",
          name: "com",
        },
        {
          label: "CUIT",
          type: "text",
          name: "cc",
        },
      ],
      [
        {
          label: "Fantasía",
          type: "text",
          name: "fant",
        },
        {
          label: "Calle",
          type: "text",
          name: "calle",
        },
        {
          label: "Altura",
          type: "text",
          name: "altura",
        },
      ],
    ],
    [tipos]
  );

  return (
    <div className="filter-container bandeja-filter" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          {tab === "comercios" ? (
            comercioFields.map((row, i) => {
              return (
                <Row key={`field-${i}`} className="mb-2">
                  {row.map((e) => {
                    if (e.type === "select") {
                      return (
                        <Col sm={12} md={4} className="mt-3" key={e.name}>
                          <Form.Label className="mb-2">{e.label}</Form.Label>
                          <Controller
                            name={e.name}
                            control={control}
                            render={({ field: { onChange, value } }) => {
                              const newValue = e.options.find(e => e.value === value);

                              return (
                                <Select
                                  options={e.options}
                                  value={newValue}
                                  onChange={(e) => {
                                    handleChange(e);
                                    return onChange(e?.value);
                                  }}
                                />
                              );
                            }}
                          />
                        </Col>
                      );
                    }
                    else {
                      return (
                        <Col sm={12} md={4} className="mt-3" key={e.name}>
                          <Form.Label className="mb-2">{e.label}</Form.Label>
                          <Form.Control
                            type={e.type}
                            name={e.name}
                            placeholder={e.label}
                            {...register(e.name)}
                          />
                        </Col>
                      );
                    }
                  })}
                </Row>
              );
            })
          ) : (
            fields.map((row, i) => {
              return (
                <Row key={`field-${i}`} className="mb-2">
                  {row.map((e) => {
                    if (e.type === "select") {
                      return (
                        <Col sm={12} md={3} className="mt-3" key={e.name}>
                          <Form.Label className="mb-2">{e.label}</Form.Label>
                          <Controller
                            name={e.name}
                            control={control}
                            render={({ field: { onChange, value } }) => {
                              const newValue = e.options.find(e => e.value === value);

                              return (
                                <Select
                                  options={e.options}
                                  value={newValue}
                                  onChange={(e) => {
                                    handleChange(e);
                                    return onChange(e?.value);
                                  }}
                                />
                              );
                            }}
                          />
                        </Col>
                      );
                    }
                    else {
                      return (
                        <Col sm={12} md={3} className="mt-3" key={e.name}>
                          <Form.Label className="mb-2">{e.label}</Form.Label>
                          <Form.Control
                            type={e.type}
                            name={e.name}
                            placeholder={e.label}
                            {...register(e.name)}
                          />
                        </Col>
                      );
                    }
                  })}
                </Row>
              );
            })
          )}

          <Row className=" d-flex justify-content-end mt-3" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                ref={reference}
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(tags).filter((e) => e !== "").length && (
              <div className="tags" >
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}

            {tags?.apynom &&
              <div className="tags">
                <span key="apynom" >
                  Nombre : {tags.apynom}
                </span>
              </div>}

            {fields.flat().map(e => {
              return tags[e.name] &&
                <div className="tags" key={e.name}>
                  <span >
                    {e.label} : {tags[e.name]}
                  </span>
                </div>;
            })}
          </Row>
        }
      </>
    </div>
  );
};
